import * as React from "react";

import {
  withTheme,
  AppBar,
  Toolbar,
  IconButton,
  List,
  Typography,
  Card,
  CardActionArea,
  Divider,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import s from "./ordersDialog.module.css";
import moment from "moment-timezone";
import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";

class OrdersDialog extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
    };
  }

  async componentWillMount() {
    await this.context.global.getUserOrders();
  }

  closeOrdersDialog = () => {
    this.props.history.goBack();
  };

  render() {
    const { orders } = this.context.global.data;

    if (orders === null) {
      return <div />;
    }

    let activeOrders = [];
    let closedOrders = [];

    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];
      if (
        order.fullfilledTimestamp ||
        moment().subtract(30, "m").format("X").valueOf() >
          order.popUpLocationInstance.pickupTimestampEnd ||
        order.cancelled
      ) {
        closedOrders.push(order);
      } else {
        activeOrders.push(order);
      }
    }

    return (
      <>
        <AppBar className={s.shoppingCartAppBar}>
          <Toolbar className={s.shoppingCartToolbar}>
            <div className={s.appBarContentContainer}>
              <div className={s.addressContainer}>
                <Typography variant="body1" style={{ color: "white" }}>
                  Orders
                </Typography>
              </div>
            </div>
            <div className={s.closeButtonContainer}>
              <IconButton
                color="inherit"
                onClick={() => this.closeOrdersDialog()}
                aria-label="Close"
                className={s.shoppingCartAppBar}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ margin: "70px 0" }} />
        <div className={s.orderGroupTitles} style={{ color: "#222222" }}>
          Upcoming Orders
        </div>
        <List>
          {activeOrders.length > 0 ? (
            activeOrders.map((order) => {
              return this.orderTiles(order);
            })
          ) : (
            <Typography
              variant="body1"
              style={{
                // color: theme.palette.primary.main,
                color: "#222222",
                padding: "30px 20px",
                textAlign: "center",
              }}
            >
              No orders scheduled
            </Typography>
          )}

          <Divider />
        </List>
        <div className={s.orderGroupTitles} style={{ color: "#222222" }}>
          Past Orders
        </div>
        <List>
          {closedOrders
            .sort((a, b) => b.fullfilledTimestamp - a.fullfilledTimestamp)
            .map((order) => {
              return this.orderTiles(order);
            })}
        </List>
      </>
    );
  }

  orderTiles = (order) => {
    return (
      <div
        key={order.uuid}
        style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}
      >
        <Card onClick={() => this.props.history.push(`/orders/${order.uuid}`)}>
          <CardActionArea>
            <div
              className={s.calloutContainer}
              style={
                order.fullfilledTimestamp ||
                moment().subtract(30, "m").format("X").valueOf() >
                  order.popUpLocationInstance.pickupTimestampEnd
                  ? { minHeight: "125px" }
                  : null
              }
            >
              {order.fullfilledTimestamp ||
              moment().subtract(30, "m").format("X").valueOf() >
                order.popUpLocationInstance.pickupTimestampEnd ? null : (
                <>
                  {/* <div
                    className={s.calloutImageContainer}
                    style={{
                      backgroundImage: `url(${order.popUpLocationInstance.popUpLocation.imageUrl})`,
                      content: "",
                      opacity: 0.3
                    }}
                  /> */}

                  <div className={s.calloutContent}>
                    <div className={s.calloutName}>
                      {order.popUpLocationInstance.fulfillmentType ===
                      "DELIVERY" ? (
                        <>
                          <div className={s.calloutSubheader_type}>
                            Delivery
                          </div>
                          <div className={s.calloutHeader}>
                            {order.deliveryLocation.address1}
                          </div>
                          <div className={s.calloutSubheader}>
                            {order.deliveryLocation.address2}
                            <br />
                            {order.deliveryLocation.city}{" "}
                            {order.deliveryLocation.state}{" "}
                            {order.deliveryLocation.zip}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={s.calloutSubheader_type}>Pickup</div>
                          <div className={s.calloutHeader}>
                            {order.popUpLocationInstance.popUpLocation.name}
                          </div>
                          <div className={s.calloutSubheader}>
                            {order.popUpLocationInstance.popUpLocation.address1}
                            <br />
                            {
                              order.popUpLocationInstance.popUpLocation.city
                            }{" "}
                            {order.popUpLocationInstance.popUpLocation.state}{" "}
                            {order.popUpLocationInstance.popUpLocation.zip}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div
                className={s.calloutNumber}
                style={{ flexDirection: "column" }}
              >
                {order.cancelled ? (
                  <div
                    style={{
                      color: "red",
                      fontVariant: "small-caps",
                      fontWeight: "bold",
                      fontSize: 15,
                    }}
                  >
                    cancelled
                  </div>
                ) : null}

                {/* <div className={s.calloutHeader}>
                  Order Number: {order.orderNumber}
                </div> */}
              </div>

              <div
                className={s.calloutContent}
                style={
                  order.fullfilledTimestamp ||
                  moment().subtract(30, "m").format("X").valueOf() >
                    order.popUpLocationInstance.pickupTimestampEnd
                    ? { height: "100%" }
                    : null
                }
              >
                <div className={s.calloutDates}>
                  {moment(
                    order.popUpLocationInstance.pickupTimestampStart * 1000
                  ).format("dddd, MMM DD, YYYY")}
                </div>
                <div className={s.calloutTimes}>
                  {moment(
                    order.popUpLocationInstance.pickupTimestampStart * 1000
                  ).format("h:mma")}{" "}
                  -{" "}
                  {moment(
                    order.popUpLocationInstance.pickupTimestampEnd * 1000
                  ).format("h:mma")}
                </div>
                {order.fullfilledTimestamp ||
                moment().subtract(30, "m").format("X").valueOf() >
                  order.popUpLocationInstance.pickupTimestampEnd ? (
                  <>
                    {order.popUpLocationInstance.fulfillmentType ===
                    "DELIVERY" ? (
                      <>
                      <div className={s.calloutSubheader_type}>
                            Delivery
                          </div>
                        <div
                          className={s.calloutHeader}
                          style={{ fontSize: "14px" }}
                        >
                          {order.deliveryLocation.address1}
                        </div>
                        <div className={s.calloutSubheader}>
                          {order.deliveryLocation.address2}
                          <br />
                          {order.deliveryLocation.city}{" "}
                          {order.deliveryLocation.state}{" "}
                          {order.deliveryLocation.zip}
                        </div>
                      </>
                    ) : (
                      <>
                      <div className={s.calloutSubheader_type}>
                            Pickup
                          </div>
                        <div
                          className={s.calloutHeader}
                          style={{ fontSize: "14px" }}
                        >
                          {order.popUpLocationInstance.popUpLocation.name}
                        </div>
                        <div className={s.calloutSubheader}>
                          {order.popUpLocationInstance.popUpLocation.address1}
                          <br />
                          {order.popUpLocationInstance.popUpLocation.city}{" "}
                          {order.popUpLocationInstance.popUpLocation.state}{" "}
                          {order.popUpLocationInstance.popUpLocation.zip}
                        </div>
                      </>
                    )}

                    <Divider />
                    {order.fullfilledTimestamp ? (
                      <div
                        className={s.calloutDates}
                        style={{
                          color: theme.palette.primary.main,
                          paddingTop: "10px",
                        }}
                      >
                        Order Fulfilled
                      </div>
                    ) : (
                      <div
                        className={s.calloutDates}
                        style={{ color: "#870b00", paddingTop: "10px" }}
                      >
                        Order Not Picked Up
                      </div>
                    )}
                  </>
                ) : (
                  <div className={s.calloutEnd}>
                    Shopping time end for this hotspot:{" "}
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                      }}
                    >
                      {moment(
                        order.popUpLocationInstance.pickupTimestampStart * 1000
                      )
                        .subtract(6, "hour")
                        .fromNow()}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </CardActionArea>
        </Card>
      </div>
    );
  };
}

export default withTheme()(OrdersDialog);
